module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2l"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "ch04"
    }
  }, [_vm._v("THE FIRST THURSDAY")])]), _c('a', {
    attrs: {
      "id": "ch04"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("August 3, 2006, 1:15 a.m.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The inquisitors are nowhere to be found on this side of the state. Here, at Charlie and Megan’s rental cabin on Fremont Lake, no one knows her. The days are peaceful but the nights . . . in a tiny cabin, the nights are bad. Dreams don’t take vacations when people do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s always something, isn’t it? Always something and never nothing for Janie. Never, ever nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Like the car a doctor once told her never to drive, she craves it. Craves the rebellious never, the elusive nothing. And when the next nightmare begins, she thinks about it for real.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "ch04"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("1:23 a.m.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie shakes on a lumpy sofa. Beside her, stretched out in a reclining lawn chair, is Cabe. Asleep.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He’s dreaming about her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie watches, as she sometimes does when his dreams are sweet. Storing up memories. For later. But this . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indentfa"
  }, [_vm._v("They’re playing paintball in an outdoor field with a dozen faceless people. It looks like a video game. Cabe and Janie move through the obstacles and shoot at each other, laughing, ducking, hiding. Cabel sneaks up and takes two shots at Janie, two red paintballs.")]), _vm._v(" "), _c('p', {
    staticClass: "indentf"
  }, [_vm._v("They nail her right in the eyeballs.")]), _vm._v(" "), _c('p', {
    staticClass: "indentf"
  }, [_vm._v("Red paint drips down her cheeks, her eye sockets hollow.")]), _vm._v(" "), _c('p', {
    staticClass: "indentf"
  }, [_vm._v("He keeps shooting and takes out one limb at a time, until Janie is just a body and a paint-striped face.")]), _vm._v(" "), _c('p', {
    staticClass: "indentf"
  }, [_vm._v("He sobs, remorseful, kneels next to her on the ground, and then picks her up and carries her, puts her in a wheelchair. Rolls her away to an empty part of the field and dumps her out onto the yellow grass.")]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Janie pulls out of it. Knows she shouldn’t be wasting dreams. But she can’t help it. She can’t look away.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("When she can see, she stares in the dark at the ceiling while Cabe tosses and turns. She slides her arm over her ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("eyes, trying to forget. Trying to pretend like this hasn’t been happening for two months straight, on top of everything else. “Please stop,” she whispers. “Please.”")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("4:23 a.m.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He dreams and she is forced awake again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She holds her head.")]), _vm._v(" "), _c('p', {
    staticClass: "indentfa"
  }, [_vm._v("Janie and Cabel are in the backyard of Cabe’s house, sitting in the green grass. Janie’s arms end at the elbows. Her eyes are sewn shut, needles still connected and hanging from the thread, down her cheeks. Black tears.")]), _vm._v(" "), _c('p', {
    staticClass: "indentf"
  }, [_vm._v("Cabel is frantic. He pulls an ear of corn from a paper grocery bag and strips the silk away. Attaches it to one of Janie’s elbows. He plucks two marbles from the paper bag. Big brown Tiger’s Eye shooters. He pushes them into Janie’s sewn-up eyelids, pushes hard, but they won’t stick. Janie falls over backward like a rag doll, unable to catch herself without hands. The ear of corn breaks off her elbow and rolls away. Cabe cradles the Tiger’s Eye marbles in his hands.")]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Janie, numb, can’t watch anymore. And she won’t try to change it. Not a dream like that. Because it’s about her, and how Cabe is dealing with things. It feels completely wrong to manipulate that. She just hopes he never asks her to help.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Still, she doesn’t want him dreaming it, period. Not any of it. She kicks out her leg. Connects. Everything goes black.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sorry,” he mumbles. Goes back to sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("It’s been like this.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s like everything he can’t say comes out in his dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("9:20 a.m.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Familiar stirrings put an end to dreams. A welcome relief. Janie rests on her couch half-asleep. Talking herself back up. Back to normalcy. She puts on her facade.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Until she can figure out what to do about it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("About life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("About him.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("9:33 a.m.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She hears the lawn chair creak, and then feels Cabel snuggling up behind her on the sofa. She stiffens, just a little. Just for a second. Then takes a deep breath. He slips his warm fingers under her cami and slides them across her belly. She smiles and relaxes, eyes still closed. “You’re going to get us in trouble,” she says. “You know your brother’s rules.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("“I’m on top of the blanket. You’re under it. They’ll ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("be okay with that. Besides, I’m not doing anything.” He strokes her skin, kisses her shoulder. Slips his fingers under the waistband of her jammie pants.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Dude.” Janie links her fingers in his. “Nope,” she calls out, in case Charlie and Megan are paying attention. “Nothing happening over here.” She murmurs to Cabel, “You’re making breakfast. Right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Right. I’m starting the fire with my mind, frying bacon with my darkest, crispiest thoughts. And you thought you had a special ability. Think again, missypants.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie laughs, but it comes out strained. “Did you sleep okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah.” His chin scratches her shoulder. “Well, as good as anybody can sleep on weaved strips of fibrous plastic and a metal rod riding his ass.” He nips her earlobe and adds, “Why? Did I have a nightmare? You always make me nervous when you ask that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shh,” Janie says. “Go make me some bacon.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He’s quiet for a moment, and then he gets up. Slips into his jeans. “Okay, then.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("9:58 a.m.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They do vacationy things. Sitting around with Charlie and Megan, drinking coffee, making breakfast over the campfire. Relaxing. Getting to know one another better.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie’s distracted.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("She stares at everything, afraid she’ll miss something that needs to be seen before it’s too late.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She really doesn’t know how to do vacations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Besides, some stuff you just can’t get away from.")]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("But she’s brave. Everything appears normal. Even though inside, she’s wrecked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s been a tough few months.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Facing them—Doc, Happy, and Dumbass—was way more difficult than she thought it would be. Reliving all the lies. The setup. The assaults. All the things those teachers did. It was horrible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now it’s over, the buzz has died down, but things are still hard. Getting on track again, and facing the reality of a blind and crippled future—it’s hard. Having a mother who’s a drunk is hard too. Thinking about college, where sleeping people are everywhere . . . and a boyfriend, whose doubts and fears only come out in his dreams. Life in general . . . yeah. All of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Really.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fucking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hard.")]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Janie and Cabe do the dishes together. Cabel washes, Janie dries. It feels so homey. She grips a plate tightly, wiping it with the towel. Thinking.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Wants to know if he’ll voice his dream fears.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("And so she blurts it out. “Do you ever think about what it’ll be like? You know, if we stick together, and me all blind and hobbling around, dropping and breaking dishes ’cause I can’t hold on to them . . . . ” She puts the plate in the cupboard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabel flicks his fingers at her, spraying her with water. Grinning. “Sure. I think I’m pretty lucky. I bet blind people have great sex. I’ll even wear a blindfold so it’s fair.” He bumps his hips lightly against hers. She doesn’t laugh. She steadies herself and then grabs a stainless steel skillet by the handle and starts drying it. Stares at her contorted reflection in it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey,” Cabe says. He dries his hand on his shorts and then strokes Janie’s cheek. “I was just joking around.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know.” She sighs and puts the pan away. Throws the towel on the counter. “Come on. Let’s go do something fun.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("1:12 p.m.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She focuses her mind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s cold in the water, but the afternoon sun is warm on her face, her hair.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Janie bobs in place, knees bent, arms straight but not locked, trying to balance. The life vest knocks about her ears. Her well-toned arms are like sticks shooting from the ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("vest’s enormous sockets. Janie’s glasses are safely stowed inside the boat, so everything is blurry. It’s like looking through a wall of rain.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She takes a deep breath. “Hit it!” she yells, and then she is yanked forward, knees knocking, arms shaking. She grips the rope handle, knuckles white, palms and muscles already sore from two previous days’ efforts. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Lean back,")]), _vm._v(" she remembers, and does it. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Let the boat pull you up.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She straightens, sort of.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Wobbles and catches herself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her bum sticks out, she knows. But she can’t help it. Doesn’t care, anyway. All she can do is grin blindly as spray slaps and stings her face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She’s up. “Woo hoo!” she yells.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Megan is a gentle driver at the wheel of the little pea-green speedboat. She watches Janie in the rearview mirror like the good mothers watch their children, her brow furrowed in concern but nodding her head. Smiling.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabel faces Janie, in the spotter position at the back of the boat, grinning like he does. His teeth gleam white next to his tan skin, and his brown hair, streaked with gold from the sunshine, flips wildly in the wind. His nubbly burn scars on his belly and chest shine silvery brown.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But they are both just blobs to Janie from seventy-five feet away. Cabe yells something that sounds enthusiastic but it’s lost in the noise of the motor and the splash.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Janie’s legs and arms shiver as they air-dry and then get slapped with spray again. Her skin buzzes.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Megan keeps them close to the willow-treed shore. As they approach the town’s beach and campground, Megan eases the boat into a wide semicircle, turning them around. Janie tenses into the turn, but it’s only a mild bump over the wake. Once they straighten out again, Janie moistens her lips, and then, determined, she gives Megan the thumbs-up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Faster.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Megan complies, and speeds toward the dock near the little red-brown shellacked cabin, one of six dotting the shore at the Rustic Logs Resort, and then she continues past it. Exploring new territory.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("I am such a badass,")]), _vm._v(" Janie thinks. She squints and makes a daring and ultimately successful attempt to cross the wake again as the two in the boat cheer her on.")]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("By the time Janie senses it, it’s already too late.")]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("A woman lies sunning herself on a water trampoline, skin gleaming from tanning oil and sweat. Janie can’t make out the scene, but she’s all too familiar with the warning signs. Her stomach twists.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Janie flies past the woman and becomes engulfed in darkness. There’s a three-second-flash of a dream before ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("it’s all over and she’s out of range again. But it’s enough to throw Janie off-kilter. Her knees buckle, skis tangle underneath her, and she flips forward wildly, water forcing its way into her throat and nostrils. Into her brain, it seems, by the way it burns. A ski slams into her head and she’s forced back under the water. She’s not slowing down.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("If you fall, let go of the rope.")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Der.")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Janie surfaces, coughing and sputtering, her head on fire. Amazed that the oversize life vest is still attached, though she’s all twisted up in it. Feels queasy after swallowing half the lake. She wipes the water from her stinging eyes and peers through the blur, disoriented, wishing for her glasses. Ears plugged. When weeds suddenly tickle her dangling feet, she "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("eep")]), _vm._v("s and her body does a little freak-out spasm of oogy-ness, after which she tries not to think about being surrounded by big yellow-orange carp . . . and their excrement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Blurg. Not fond of this, hello.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Boats whine in the distance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("None of them sounds like it is coming to rescue her.")]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Finally she hears a muffled chugging. When the motor cuts, Janie calls out. “Cabe?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s still the only name that feels safe on her tongue.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("1:29 p.m.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In the boat, Cabel wraps a towel around her. Hands Janie her glasses. “You sure you’re okay?” His eyes crinkle and he’s trying not to grin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fine,” Janie growls, peeved, teeth chattering. Megan checks out the bump on Janie’s head, and then hauls in the tow rope.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabel coughs lightly and then presses his lips together. “That was quite, uh, quite the display, Hannagan.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you actually laughing at me? Seriously?” Janie rubs her hair with a towel. “I almost died out there. Plus my brain is now infested with plankton and carp shit. You’d better watch it, or I’ll blow a snot rocket at you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m . . . eww. That’s disgusting.” Cabe laughs. “But seriously, you really should have seen yourself. Right, Megan? I wish we had a video camera.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Dude, I am so Switzerland,” Megan says. Rope stowed, she revs up the engine and swings the boat around, back to the dock.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For the second time today, Janie’s not laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabel continues over the noise. “I mean, the flip was one thing, but the drag, that was something entirely out of control. Your legs were flying. Remember rule number one of water skiing?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("“I know. Sheesh. When you fall, let go of the rope, I ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("know. There’s just a lot of shit to remember when you’re out there.”")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabel snorts. “A lot . . . yeah, a whole lot of shit to remember.” He laughs long and hard, wipes his eyes and tries to get control of himself. “Shouldn’t ‘let go of the rope if it’s drowning you’ be sort of an automatic response, though? Basic survival technique?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She glares at him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He stops laughing and gives her a helpless, innocent look. “Okay, okay, I’m sorry,” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Go suck a mean one,” Janie says. She turns away and squints through her glasses, locating the sleeping woman on the trampoline, now a tiny island in the distance. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("You still don’t catch it all, do you, Cabe?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He probably never will.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Get over yourself, Hannagan,” she mutters. “You’re on vacation, damn it. You’re relaxing and having fun.” It sounds wooden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s that, sweets?” He slides over to her on the bench seat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I said, it "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("was")]), _vm._v(" kinda funny, wasn’t it?” Janie looks into Cabel’s eyes. Smiles sheepishly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With his finger, he catches a drip of water from her chin. Smiles. He brings his finger to his lips and licks the water. “Mmm,” he says, nuzzling her neck. “Carp shit.”")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("1:53 p.m.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabel nods off on a blanket under a shady oak.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie sits, chin on her knees, staring at her toes. Listening to the rhythm of the soft waves washing up on shore. After a while, she gets up. “I’m going for a walk,” she whispers. Cabel doesn’t move.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She slips a long T-shirt over her swimsuit, shoves her toes in her flips, grabs her cell phone, and walks behind the cabin and through the little parking lot, up the steep driveway to the main road. Across the road there’s a field and a railroad track. The rails glint in the late afternoon sunshine. Janie walks along the track and thinks, glad to have a quiet place where she can let her dream guard down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After a while, she stops walking. Sits on the track, feeling the hot metal against the backs of her thighs through the thin cover-up. Opens her phone and dials memory #2.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Janie—what’s going on? Everything all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie gently waves a bumblebee away. “Hi. Yeah. I’m just doing a lot of thinking. About what we talked about . . . you know? Lots of time to think on vacation,” she says, and laughs nervously.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And . . . you’re sure you are okay with whatever I decide?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course. You know that. Did you make up your mind, then?")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("“Not really. I’m—I’m still deciding.”")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Have you talked to Cabel about it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie winces. “No. Not yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I don’t blame you for wanting—and needing—to consider all of your options.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie’s throat grows tight. “Thank you, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know the drill. Call me anytime. Let me know what you choose.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I will.” Janie closes the phone and stares at it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There’s nothing more to say.")]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("On the way back, she picks up a train-flattened penny from the track and wonders if one of the vacationers down the hill placed it there. Wonders if some excited little kid will come back for it. She sets it on the railroad tie so whoever it is will be sure to see it. Walks slowly back to the cabin to drop off her stuff. And then it’s back outside, under the tree.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She watches Cabe sleep. Later, she dozes too, whenever she can get a chance while she wearily dodges Cabel’s dreams, and the dreams of a sleeping child somewhere, probably in the cabin next door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is no getting away from it all here. Or anywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No escape for her.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("5:49 p.m.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("A whistle blasts and the train rushes past up at the top of the hill. Everyone who was sleeping awakes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Another busy day at the lake,” Cabel murmurs. “My stomach’s growling.” He rolls over on the blanket. Janie can’t resist. She snuggles up to his warm body.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can hear it,” she says. “And I smell the charcoal grill.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We should really get up now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They remain still, Janie’s head on Cabel’s chest, a nice breeze coming off the lake. She squinches her eyes shut and holds him, takes in the scent of him, feels the warmth of his chest on her cheek. Loves him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Breaks a little more inside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("6:25 p.m.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie hears the click of the cabin’s screen door and sits up guiltily as Megan walks over to them. “I’m sorry, Megan—we should be helping you get dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nah,” Megan grins. “You needed a nap after all that skiing and drowning. But your cell phone is beeping inside the cabin. I don’t know what to do with it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thanks. I’ll check it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabel sits up too. “Everything okay? Where’s Charlie, anyway?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("“In town picking up some groceries. It’s all good. ")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Relax,” Megan says. “Seriously. It’s been a tough time for you guys—you need the rest.”")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Obediently, Cabel sinks back down on the blanket as Janie gets to her feet. “Be right back,” she says. “It better not be Captain with an assignment or I’m quitting.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabel laughs. “You wouldn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("6:29 p.m.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Voice mails.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From Carrie. Five of them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And they’re bad.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie listens, incredulous. Listens again, stunned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, Janers, dammit, where are you? Call me.” "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Click.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Janie, seriously. There’s something wrong with your mom. Call me.” "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Click.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Janie, seriously! Your mom is stumbling around your front yard yelling for you. Didn’t you tell her you were going to Fremont? She’s totally drunk, Janie—she’s wailing and—oh, shit. She’s in the road.” "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Click.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey. I’m taking your mom to County Hospital. If she blows in Ethel, you are so dead. Call me. Jesus. Also? Shit. My phone battery is dying, so maybe try the hospital or something . . . don’t know what to tell you. I’ll try you "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("again")]), _vm._v(" when I have a chance.” "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Click.")])])]), _c('p', {
    staticClass: "indenta"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("“Oh, my God.” Janie stares at her phone, not really seeing it. Then she calls Carrie.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Gets Carrie’s voice mail. “Carrie! What happened? Call me. I’ve got my phone now. I’m so sorry. I was—taking a nap.” It sounds hollow. Careless. Frivolous, even, when Janie says it aloud. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("What was I thinking, leaving my mother alone for a week?")]), _vm._v(" “God. Just call me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie stands there, all the breath being sucked out of her, replaced by fear. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("What if something’s really wrong?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And then anger.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("I will never have a life as long as that woman is alive,")]), _vm._v(" she thinks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Squeezes her eyes shut and takes it back, immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Can’t believe she would be such a horrible person, think such a horrible thing.")]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Charlie walks into the tiny cabin kitchen with a brown bag of groceries and stops short when he sees the look on Janie’s face. “Are you okay?” he asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie blinks, unsure. “No, I don’t think so,” she says quietly. “I think . . . I think I have to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Charlie sets the groceries down hard on the counter. “Cabe!” he shouts through the screen door. “Come ’ere.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Janie sets her phone down and pulls her suitcase from the wardrobe. Starts throwing her clothes in her suitcase. She looks at her disheveled self in the mirror and rakes ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("her fingers through her dark blond tangles. “Oh, my God,” she says to herself. “What the hell is wrong with my mother?”")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("And then it hits.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What if her mother really is dying? Or dead?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s both fascinating and horrifying. Janie imagines the scene.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What is it?” Cabel says, coming into the cabin. “What’s going on?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Here,” she says. She dials voice mail and hands the phone to Cabel. “Listen to all the messages.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Cabel listens, Janie, in a daze, continues to pack.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After all her things are crammed inside, she realizes that she needs something to change into—she can’t drive all the way to Fieldridge in her swimsuit.")]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("She can’t drive at all.")]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Cue major detail.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fuck,” Janie mutters. She watches as Cabel listens to the messages. Watches his expression intensify.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Holy shit,” he says. He looks at Janie. Takes her hand. “Holy shit, Janie. What can I do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie just buries her face in his neck. Trying not to think.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Endless.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("7:03 p.m.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s a three-hour drive home. Cabel’s at the wheel of the Beemer that Captain Komisky lets him drive. A Grand Rapids radio station deejay cracks a lame joke and then plays Danny Reyes’s “Bleecker Street” in his all-request hour, and Janie stares at her phone, willing Carrie to call. But it’s silent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie calls the hospital. They have no record of a Dorothea Hannagan being admitted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe she’s fine and they didn’t have to admit her,” Cabel says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Or maybe she’s in the morgue.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They’d have called you by now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie’s silent, trying to think of reasons why the hospital hasn’t called, much less Carrie with an update.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We can call Captain,” Cabel says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What good will that do?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The police chief? She can get info from anybody she wants.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“True. But . . . ” Janie sighs. “I don’t . . . my mother . . . never mind. No. I don’t want to call Captain.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why? It would put your mind at ease.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Cabe . . . ”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Janie, seriously. You should call her—get the scoop. She’d totally do it for you if you’re worried about imposing.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("“No thanks.”")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You want me to call her?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. Okay? I don’t want her to know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabel sighs, exasperated. “I don’t get it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie clenches her jaw. Looks out the window. Feels the heat in her cheeks, the tears stinging. The shame. Says softly, “It’s embarrassing, all right? My mom’s a freaking drunk. Stumbling around in the front yard, yelling? My God. I just don’t need Captain seeing that. Or knowing about that—that part of my life. It’s personal. There are things I talk about with Captain, and things that are private. Just drop it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabel is silent. After a few minutes of radio deejay babble, he plugs his iPod into the car stereo. Josh Schicker’s “Feels Like Rain” washes through the car. When the song ends and the first notes of the next song begin, he stiffens and then hastily flips it off. Knows what’s next. Knows it’s “Good Mothers, Don’t Leave!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An hour passes as they travel eastward across Michigan, leaving the sun setting orange and bright in their wake. Traffic is light. Janie leans her head against the window, watching the blur of deep green trees and yellow fields pass by. There’s a deer in a grassy area as darkness approaches—or maybe it’s just that burned-out tree stump that fools her every time.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("She wonders how many more times she’ll witness ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("scenes like this. Trying to remember everything she sees now, for later. When all she has is darkness and dreams.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She tries the hospital again. Still no record of Dorothea Hannagan. It’s a good sign, Janie thinks . . . except that Carrie still isn’t calling. “Where is she?” Janie bounces her head against the headrest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabel glances sidelong at Janie. “Carrie? Didn’t she say her phone’s dead?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She said her battery was low. But there are other phones . . . . ”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabel taps his chin thoughtfully. “Does she actually know your cell number or are you on her speed dial?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ahh. Good point. Speed dial.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So that’s why she hasn’t called. She doesn’t know your number, it’s in her dead phone and she can’t get to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie smiles. Lets go of a worried breath. “Yeah . . . you’re probably right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you try calling your house to see if your mom is there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, I did that, too. No answer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you have Stu’s number? Or Carrie’s home phone?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I tried her home. No answer. And I don’t have Stu’s. I should. I’ve always meant to . . . . ”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What about Melinda?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("“Yeah, right.” Janie snorts. “Just what I need—the knobs from the Hill spreading this story around.” She turns back to the window. “I’m sorry I was snippy. You know—earlier.”")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabel smiles in the darkness. “S’okay.” He reaches for Janie’s hand. Snakes his fingers between hers. “I wasn’t thinking. My bad.” He pauses. “You know nobody thinks badly of you for things you can’t control, like what your mother does.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nobody?” Janie scowls. “Right. They all have their opinion on the Durbin mess.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nobody who matters.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie tilts her head. “Yanno, Cabe, maybe neighbors, the entire town of Fieldridge . . . maybe what they think actually does matter to me. I mean, God. Forget it. I’m just so tired of all of this. Sheesh, what next?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After a pause, Cabel says, “Straight to the hospital, then, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, I figure that’s the best thing we can do. She could just be sitting, waiting in the ER. We’ll try that first . . . you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("9:57 p.m.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Janie and Cabel stand in the ER, unsure of what to do. No sign of Carrie or Janie’s mother anywhere among the ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("assortment of ill and injured. No one at the desk has any record of her either.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabel taps his fingers against his lips, thinking. “Is Hannagan your mom’s married name?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie squinches her eyes shut and sighs. “No.” She’s never told Cabel much about her mother, and he’s never asked. Which was just the way Janie liked it. Until now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Um . . . ?” Cabel prompts. “How do I put this PC. Let’s see. Okay, has your mom ever gone by any other name besides Hannagan?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. Her name’s Dorothea Hannagan, and that’s the only name she’s ever had. I’m a bastard. Okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Janie, seriously. Nobody cares about that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, well, I care. At least you know who both your parents are.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabel stares at Janie. “Fat lot of good that did me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, jeez, Cabe.” Janie grimaces. “I’m sorry. Major verbal typo. I’m stressed—I don’t know what I’m saying.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabel looks like he’s about to say something, but he holds back. Looks around again, futilely. “Come on,” he says, grabbing Janie’s hand. “Elevator. We’ll walk around, check waiting rooms. Ten minutes, tops, and if we don’t find Carrie, we head back to your house and wait. I don’t know what else to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A shiver crawls over Janie’s skin. Her mother, the drunk, is missing.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("10:02 p.m.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("There, in the third-floor waiting room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("ICU.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Elbows on her knees and face in her hands, fingers threaded through her long dark curls. Leaning forward. Like she’s ready to jump to her feet at any second and run like hell.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Carrie!” Janie says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Carrie pops up. “Oh, good, you got my note.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where’s . . . Is my mother . . . ?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s in the room with him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What? Who?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Didn’t you get my note?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What note? All I know is what you left on my voice mail.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I left a note on Ethel—in the parking lot. Figured you’re a detective now, or whatever. You oughta think to look for my car. Anyways, how the hell did you find me, then? Never mind. Your mom—she’s fine. I mean, she’s still drunk but I think she’s coming down now . . . like way down. She’s all weepy and shaky. But—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Carrie,” Janie says firmly. “Focus. Tell me what’s wrong with my mother and where I can find her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Carrie sighs. She looks tired. “Your mom is fine. Just drunk.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Janie glances nervously through the open door to the ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("hallway as a nurse walks by. Her voice is low and urgent. “Okay, okay, I get that she’s drunk. She’s always drunk. Can we stop shouting that please? And if she’s fine, why the fuck are we all in Intensive Care?”")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, man,” Carrie says. She shakes her head. “Where to start?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabel nudges Janie and Carrie toward the chairs and sits down with them. “Who’s ‘him’, Carrie? Who is she with?” he says gently.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie nods, echoing the question.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But she already knows.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There’s only one “him” it could possibly be. There is no one else in the world. No one else that would make Janie’s mother react this way. No one else Janie’s mother dreams about.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Carrie, whose normally dancing eyes are dulled from the weariness of the unusual day, looks at Janie. “Apparently, it’s your father, Janers. He’s, like, really sick.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie just looks at Carrie. “My father?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They don’t think he’s going to make it.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("10:06 p.m.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie falls back into the chair. Numb. No idea how she’s supposed to feel about this news. No. Freaking. Clue.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Cabel lifts his hand to pause the conversation. The three sit in the waiting room in silence for a moment, Janie ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("looking blank, Carrie working a piece of gum, Cabel closing his eyes and shaking his head ever so slightly. “Start from the beginning,” he says.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Carrie nods. Thinks. “Yeah, so, this afternoon, probably around three o’clock, I heard somebody hollering outside. I ignored it ’cause there’s always somebody yelling around our neighborhood, right? And I’m folding laundry on the bed and then through my window I see Janie’s mom, which is so weird, because she, like, never goes outside unless she’s walking to the gas station or the bus stop to get booze, right? But today she’s in her nightgown wandering around the yard—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie flushes and puts her hands to her face. “Oh, God,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“—and, uh, she’s calling ‘Janie! Janie!’ and then she sort of stumbles and I go running outside to see what’s wrong with her. And Dorothea, she’s crying and says, ‘The phone! I gotta go to the hospital,’ over and over about twenty times, and I’m calling you and leaving you messages and finally I just drive her here ’cause I don’t know what else to do. And it takes us like an hour of sitting in the ER and talking to the receptionist before she’s . . . um . . . calmed down and able to explain that she’s not sick—that she got a phone call and she needs to see Henry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie looks up. “Henry?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, Henry Feingold. That’s the guy’s name.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("“Henry Feingold,” Janie says. The name sounds empty. It has no meaning to her. It doesn’t sound like what she imagined her father’s name would be. “How would I even know if that’s him? Dorothea,” she says, emphasizing each syllable, “never bothered to share any information with me about him.”")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Carrie nods solemnly. She knows.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And then.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie blinks back the tears as she realizes the truth. “He must live nearby if they brought him here. Guess he didn’t ever bother to know me, either.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry, hon.” Carrie looks at the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie stands abruptly and turns to Cabel and Carrie. “I can’t believe she ruined our vacation. And I’m so sorry, Carrie, that you wasted your whole day and evening here. You are such a good friend—please, go on home or to Stu’s or whatever.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She turns to Cabel. “Cabe, I’ll handle this from here. I’ll take the bus home once I collect my mother. Please, guys. Go get some rest.” She walks toward the door, hoping Carrie and Cabe will follow so she can usher them out and suffer the embarrassment of all of this in private. Her bottom lip quivers. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("God, this is so fucked up.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabel stands up, and then Carrie stands too. “So,” Cabel says to Carrie as they follow Janie to the door. “What’s wrong with him? Do you know?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("“Some brain injury or something. I don’t know much—I heard the doc tell Dorothea that he called 911 and was still conscious until after he got here, but now he won’t wake up. They finally let Dorothea in to see him about thirty minutes ago. And Janers,” Carrie says, “it was no problem, okay? You’d do the same if my mom needed help. Right?”")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie’s throat tightens and she blinks back the tears. All she can do is nod. When Carrie hugs her, Janie chokes back a sob. “Thanks,” Janie whispers in Carrie’s hair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Carrie turns to go. “Call me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie nods again, watching Carrie walk to the elevators. And then she looks at Cabel. “Go,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He’s not going anywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie sighs uneasily. Because it’s great he’s so supportive, but this situation is totally weird. And Janie’s not quite sure what to expect.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some things are really just easier done alone.")])]), _c('p', {
    staticClass: "indenta"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("It’s quiet and the lights are low as Janie and Cabel push through the double doors into the ICU patients’ hallway. Janie feels the faint pull of a dream from a distance and she combats it immediately, impatiently. Spies the culprit’s room whose door stands ajar and silently curses him. Frustrated she can’t ever get away from people’s ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("dreams, even when her mind is extremely busy doing other things.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("They check in at the nurses’ station. Janie clears her throat. “Henry, uh, Fein . . . stei—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Feingold,” Cabel says smoothly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you family?” the nurse asks. She looks at them suspiciously.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I, uh,” Janie says. “Yeah. He’s my . . . father . . . I guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The nurse cocks her head to the side. “The trick to getting into someone’s room is to lie "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("convincingly")]), _vm._v(",” she says. “Nice try.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I—I don’t want to go into his room. Just tell my mother I’m here, will you? She’s in there with him. I’ll be in the waiting room.” Janie turns around abruptly and Cabel shrugs at the nurse and follows. They march back through the double doors to the waiting room, leaving a puzzled nurse watching them go.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie mutters under her breath as she flings herself in a chair. “Feingold. Harvey Feingold.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabe glances at her. “Henry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Right. Jeez. You’d never guess I work for the cops.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Which is probably why you’re so convincing undercover,” Cabel says, grinning.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Janie elbows him automatically. “Well, not anymore. Don’t forget you’re talking to narc girl.” She turns to him. ")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("Grabs his hand. Implores. “Cabe, really, you should go. Get some sleep. Go back to Fremont and enjoy the rest of the week. I’m fine here. I can handle this.”")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabel regards Janie and sighs. “I know you can handle it, Janie. You’re such a damn martyr. It’s tiring, really, having this same argument with you every time you’ve got shit happening. Just let it go. I’m not leaving.” He smiles faux-diplomatically.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie’s jaw drops. “A martyr!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ahh, yeah. Slightly.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please. You can’t be "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("slightly")]), _vm._v(" a martyr. You either are, or you aren’t. It’s like "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("unique")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabel laughs softly, the corners of his eyes crinkling. And then he just gazes at her, smiling the crooked smile that Janie remembers from the awkward skateboard days.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But right now, Janie can’t seem to smile back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Um, about this little adventure,” she begins. “This is really mortifying, Cabe. I’m . . . I’m so embarrassed about it, and I have a lot on my mind, and I can hardly stand how nice you are being. I hate that I’m ruining your time too, instead of just my own. So, really, please. It would make me feel better if you’d just, you know . . . ” Janie gives him a helpless look.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cabel blinks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His forehead crinkles and he looks earnestly at her.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("“Ahh,” he says. “You really do want me to go home. ")]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("When you say this is embarrassing, you mean it’s embarrassing to you for "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("me")]), _vm._v(" to know this stuff too?”")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie looks at the floor, giving him the answer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh.” Cabel measures his words, stung. “I’m sorry, Janers. I didn’t pick up on that.” He gets up quickly. Walks to the door. Janie follows him to the hallway by the elevators. “I’ll . . . I’ll see you around, I guess,” he says. “Call me when—whenever.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I will,” Janie says, staring at the big "), _c('span', {
    staticClass: "small"
  }, [_vm._v("CELL PHONES MUST BE TURNED OFF")]), _vm._v(" sign on the wall. “I’ll text you later. This is just really something I’d rather handle alone at the moment, okay? I love you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah. Okay. Love you, too.” Cabel swivels on his flips and waves an uncertain hand at her. He looks over his shoulder. “Hey? Bus doesn’t run between two and five a.m., you know that, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie smiles. “I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t get sucked into any dreams, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay. Shh.” Janie says, hoping no one else heard that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before he can think of anything else, Janie slips back inside the waiting room to sit and think.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alone.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("1:12 a.m.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She dozes in the waiting room chair.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("Suddenly feels someone watching her. Startles and sits up, awake.")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("At least her mother is wearing clothes and not the nightgown Carrie mentioned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey,” Janie says. She stands. Walks over to her mother and stops, feeling awkward. Not sure what to do. Hug? That’s what they do on TV. Weirdness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dorothea Hannagan is sweating profusely. Shaking. Janie doesn’t want to touch her. This whole scene is so foreign it’s almost otherworldly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And then.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Madness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where were you?” Janie’s mother crumples and she starts crying. Yelling too loud. “You don’t tell me nothing about where you are, you just disappear. That strange girl from next door has to drive me here—” Her hands are shaking and her shifty eyes dart from the floor back up to Janie’s, accusing, angry. “You don’t care about your mother now, is that it? You just running around wild with that boy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie steps back, stunned, not just at the sheer record number of words uttered by her mother in one day, but even more by the tone. “Oh, my God.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("“Don’t you talk back to me.” Dorothea’s shaking hands rip open her ragged vinyl purse and she rifles through it, dumping wrappers and papers onto the waiting room ")]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("chairs. It becomes painfully obvious that what she’s looking for is not there. Dorothea gives up and slumps in a chair.")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie, standing, watches.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She’s shaking a little bit too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Wondering how to handle this. And why she has to. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Haven’t you given me enough shit to deal with already?")]), _vm._v(" she says to no one. Or maybe to God. She doesn’t know. But she does know one thing. She’ll be glad to be away from this mess.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie picks up the scattered objects from the waiting room, shoves them into the purse, and takes her mother by the arm. “Come on. You’ve got some at the house, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie tugs Dorothea to her feet. “I said, come on. We have to catch the bus.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What about your car?” Dorothea asks. “That girl was driving it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie blinks and looks at her mother, dragging her along to the elevator. “Yeah, Ma. I sold it to her months ago, remember?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You never tell me—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Just . . . ” Janie burns. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("I don’t tell you anything? Or you’re too drunk to remember?")]), _vm._v(" She takes a breath, lets it out slowly. “Just come on. And don’t embarrass me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, well don’t you embarrass me, either.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whatever.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("Janie gives a fleeting glance over her shoulder down the hallway where presumably her father lies, dead or alive, Janie doesn’t know.")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Doesn’t really care.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hopes he hurries up and dies so she doesn’t ever have to deal with him. Because from all Janie knows, parents are nothing but trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("2:10 a.m.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dorothea fidgets like a junkie the entire way home on the bus. Janie, frustrated, wards off the dream of a homeless passenger and is just glad it’s a short ride.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When they get home, there on the front step is Janie’s suitcase. “Damn, Cabe,” she mutters. “Why do you always have to be so fucking thoughtful?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie’s mother makes a beeline to the kitchen, grabs a bottle of vodka from under the sink, and retreats to her bedroom without a word. Janie lets her go. There will be time tomorrow to figure out what’s going on with this Henry person once Dorothea is good and sloshed and halfway reasonable again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie texts Cabel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Home.")])]), _vm._v(" "), _c('p', {
    staticClass: "indenta"
  }, [_vm._v("Cabe responds without delay, despite the hour.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Thx baby. Love. See you tomorrow?")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("Turns off her phone. “Yeah, about that,” Janie whispers. She sighs and sets the phone on her bedside table and her suitcase next to it, and falls into bed.")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("4:24 a.m.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janie dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "indentfa"
  }, [_vm._v("There are rocks covering her bedroom floor and a suitcase on her bed. Each rock has something scribbled on it, but Janie can only read the rocks when she picks them up.")]), _vm._v(" "), _c('p', {
    staticClass: "indentf"
  }, [_vm._v("She picks one. “HELP ME,” it reads. “CABE,” reads another.")]), _vm._v(" "), _c('p', {
    staticClass: "indentf"
  }, [_vm._v("“DOROTHEA. CRIPPLED. SECRET. BLIND.”")]), _vm._v(" "), _c('p', {
    staticClass: "indentf"
  }, [_vm._v("When she puts them back on the floor, they grow bigger, heavier. Soon, she knows, she will run out of room on the floor to put the rocks, but she can’t stop picking them up, reading them. The floor is crowded, and Janie’s having trouble breathing. The rocks are sucking the air from the room.")]), _vm._v(" "), _c('p', {
    staticClass: "indentf"
  }, [_vm._v("Finally, Janie sets a rock in the suitcase. It shrinks to the size of a pebble.")]), _vm._v(" "), _c('p', {
    staticClass: "indentf"
  }, [_vm._v("Janie slowly, methodically, picks up all the rocks and puts them in the suitcase. The task seems endless. Finally, she picks up the last one, “ISOLATE.” Sets it down with the others. It becomes a pebble, and all the other pebbles disappear.")])]), _c('p', {
    staticClass: "indentf"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("Janie stares at the suitcase. Knows what she has to do.")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "indentf"
  }, [_vm._v("She closes it.")]), _vm._v(" "), _c('p', {
    staticClass: "indentf"
  }, [_vm._v("Picks it up.")]), _vm._v(" "), _c('p', {
    staticClass: "indentf"
  }, [_vm._v("And walks out.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bff392a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch04.vue
// module id = 84
// module chunks = 0